import { Button, Checkbox } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import client from '../../../../api/client';
import icon from '../../../../assets/shareholdersIcon.png';
import { FaPlusCircle } from 'react-icons/fa';
import CustomModal from '../../../../components/Modal/CustomModal';
import CreateCustomRole from './CreateCustomRole';

const RoleAndPermission = () => {
    const [roles, setRoles] = useState<any[]>([]);
    const [permissions, setPermissions] = useState<any[]>([]);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [openPermissionModal, setOpenPermissionModal] = useState<boolean>(false)
    const [selectedRoleId, setSelectedRoleId] = useState<number>(0);
    const [activeTab, setActiveTab] = useState<number | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            await fetchRoles();
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (selectedRoleId) {
            fetchPermissions(selectedRoleId);
        }
    }, [selectedRoleId]);

    const fetchRoles = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/role/users');
            const rolesData = response.data.data;
            setRoles(rolesData);
            if (rolesData.length > 0) {
                const defaultRoleId = rolesData[0].id; // Set the first role as default
                setSelectedRoleId(defaultRoleId);
                setActiveTab(0); // Set active tab to the first tab
            }
        } catch (err: any) {
            handleError(err);
        }
    };

    const fetchPermissions = async (roleId: number) => {
        try {
            const response = await client.get(`/subsidiary/dashboard/users/roles/${roleId}/details`);
            setPermissions(response.data.data.permission);
        } catch (err: any) {
            handleError(err);
        }
    };

    const handleClick = (roleId: number, index: number) => {
        setActiveTab(index);
        setSelectedRoleId(roleId);
    };

    const handleError = (err: any) => {
        if (err?.response?.data?.message === 'Please login again') {
            sessionStorage.clear();
            window.location.href = '/';
        } else {
            console.error('error getting data', err);
        }
    };

    return (
        <div>
            <div className='flex justify-between'>
                <div className='flex gap-2 flex-wrap'>
                    {roles.map((role: any, index: number) => (
                        <div
                            key={role.id}
                            className={`border flex items-center justify-center px-2 rounded-md text-sm hover:cursor-pointer ${activeTab === index ? 'bg-gray-300' : 'bg-white'}`} // Conditionally apply background color
                            onClick={() => handleClick(role.id, index)}
                        >
                            {role.name} ({role.userCount})
                        </div>
                    ))}
                </div>
                <div className=''>
                    <Button className='bg-green-700 ml-0 mt-2 md:ml-auto md:mt-0' onClick={() => setOpenModal(true)}>Create Custom Role</Button>
                </div>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 my-16'>
                <div className='mx-4'>
                    <p className='text-3xl font-semibold mb-3'>Permissions</p>
                </div>
                <div>
                    <div>
                        <img src={icon} alt="Permissions Icon" />
                        <p className='text-lg font-semibold my-2'>Permissions</p>
                        <p className='text-sm my-2'>Kindly edit any permission</p>
                    </div>
                    <div className='my-4'>
                        {permissions.map((permission: any) => (
                            <div key={permission.id} className='flex items-center gap-3 my-2'>
                                <Checkbox checked={true} />
                                <p>{permission.permission}</p>
                            </div>
                        ))}
                    </div>
                    <div className='flex items-center gap-3 text-green-600' onClick={() => setOpenPermissionModal(true)}>
                        <FaPlusCircle />
                        <p className='font-thin'>Add New</p>
                    </div>
                </div>
            </div>
            <CustomModal
                children={<CreateCustomRole refreshPage={fetchRoles} close={() => setOpenModal(false)} />}
                title='Create Custom Role'
                subtitle='Kindly fill in the required information'
                icon={icon}
                dismissible={true}
                show={openModal}
                onClose={() => setOpenModal(false)}
            />
        </div >
    );
};

export default RoleAndPermission;
